module.exports = __webpack_public_path__ + "static/media/editor.83a9e87e.png";